const restrictToBoundingRect = ({
  transform,
  rect,
  boundingRect
}) => {
  const {
    top,
    bottom,
    left,
    right
  } = rect;
  const {
    top: boundTop,
    left: boundLeft,
    height,
    width
  } = boundingRect;
  return {
    ...transform,
    y: top + transform.y <= boundTop ? boundTop - top : bottom + transform.y >= boundTop + height ? boundTop + height - bottom : transform.y,
    x: left + transform.x <= boundLeft ? boundLeft - left : right + transform.x >= boundLeft + width ? boundLeft + width - right : transform.x
  };
};
const customRestrictToWindowEdges = (initialTransform, boundingRect) => ({
  transform,
  draggingNodeRect,
  windowRect
}) => {
  if (!draggingNodeRect || !windowRect) return transform;
  return restrictToBoundingRect({
    transform,
    rect: {
      ...draggingNodeRect,
      top: draggingNodeRect.top + initialTransform.y,
      bottom: draggingNodeRect.bottom + initialTransform.y,
      left: draggingNodeRect.left + initialTransform.x,
      right: draggingNodeRect.right + initialTransform.x
    },
    boundingRect: boundingRect || windowRect
  });
};

export { customRestrictToWindowEdges };
